import {
  instance as axios,
  setJwtToken,
  // setMultiPartHeader,
} from "../../config/axiosInstance";

// User List
export const userListApi = async (data) => {
  const endPoint = `admin/user/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Edit Student------------------
// export const editstudentApi = async (data) => {
//   const endPoint = `student/update_personal_info`;
//   return await axios.post(endPoint, data, setMultiPartHeader());
// };

// Delete User
export const deleteUserApi = async (data) => {
  const endPoint = `admin-user/delete-user?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.delete(endPoint, setJwtToken());
};

// Change User Status
export const changeStatusUserAPI = async (data) => {
  const endPoint = `admin/user`;
  return await axios.put(endPoint, data, setJwtToken());
};

//User Detail
export const userDetailApi = async (_id) => {
  const endPoint = `admin/user/?_id=${_id}`;
  return await axios.get(endPoint, setJwtToken());
};

// Export User Detail
export const userExportApi = async (_id) => {
  const endPoint = `admin/user/export`;
  return await axios.get(endPoint, setJwtToken());
};

// Export User Detail
export const myProfileApi = async (_id) => {
  const endPoint = `admin/account/my-profile`;
  return await axios.get(endPoint, setJwtToken());
};
